import React, { useState, useEffect } from 'react';
import { dashboardAPI } from '../../Api/dashboardAPI';
import { NovedadesProgramadasResponse } from '../../interfaces/novedadesProgramadas';
import TableList from '../../components/TableList/TableList';
import Pagination from '../../components/reusable/Pagination/Pagination';
import Input from '../../components/reusable/Input/Input';
import Button from '../../components/reusable/Button/Button';

const NovedadesProgramadas = () => {
  const [novedades, setNovedades] = useState<NovedadesProgramadasResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(0);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [idNovedadOrigen, setIdNovedadOrigen] = useState<number | null>(null);
  const pageSize = 10;
  
  const estados = [
    { id: 0, nombre: 'TODOS' },
    { id: 1, nombre: 'PENDIENTE' },
    { id: 2, nombre: 'EN_CURSO' },
    { id: 3, nombre: 'FINALIZADA' },
    { id: 4, nombre: 'ERROR' },
  ];

  const fetchNovedades = async (page: number = currentPage) => {
    try {
      setLoading(true);
      const response = await dashboardAPI.getNovedadesProgramadasPaginated(
        pageSize, 
        ((page - 1) * pageSize), 
        estadoSeleccionado,
        selectedId || null,
        idNovedadOrigen || null
      );
      setNovedades(response.data as NovedadesProgramadasResponse[]);
      setTotalCount(response.totalCount);
      console.log('Novedades response:', response); 
      console.log('Total count:', response.totalCount); 
    } catch (error) {
      console.error('Error al cargar novedades:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = async (newPage: number) => {
    console.log('Changing to page:', newPage);
    setCurrentPage(newPage);
    await fetchNovedades(newPage);
  };

  useEffect(() => {
    fetchNovedades(1);
  }, [estadoSeleccionado]);

  const handleEstadoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setEstadoSeleccionado(Number(e.target.value));
    setCurrentPage(1); 
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Novedades Programadas</h1>
      
      <div className="mb-4 flex flex-row items-center gap-2">
        <select
          value={estadoSeleccionado}
          onChange={handleEstadoChange}
          className="w-full md:w-64 px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:border-blue-500"
        >
          {estados.map((estado) => (
            <option key={estado.id} value={estado.id}>
              {estado.nombre}
            </option>
          ))}
        </select>
        <Input
          placeholder="ID"
          value={String(selectedId)}
          onChange={(selectedId) => setSelectedId(Number(selectedId))}
          type="number"
        />
        <Input
          placeholder="ID Novedad Origen"
          value={String(idNovedadOrigen)}
          onChange={(idNovedadOrigen) => setIdNovedadOrigen(Number(idNovedadOrigen))}
          type="number"
        />
        <Button
          className="ml-3"
          label="Actualizar listado"
          iconName="arrow-clockwise"
          onClick={() => fetchNovedades(1)}
        />
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        {loading ? (
          <div className="text-center">Cargando...</div>
        ) : (
          <>
            <div className="grid gap-4">
              <TableList list={novedades} page="novedades_programadas" />
            </div>
          
            {totalCount > 0 && (
              <div className="mt-4">
                <Pagination
                  totalCount={totalCount}
                  onPageChange={handleChangePage}
                  currentPage={currentPage}
                  pageSize={pageSize}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NovedadesProgramadas;